console.log('mazing-integration file loaded');

const scriptTag = document.createElement('script');
scriptTag.src = 'https://cdn.mazing.link/mzg-in.js';
scriptTag.type = 'text/javascript';
scriptTag.crossOrigin = 'anonymous';
scriptTag.defer = true;
document.head.append(scriptTag);
// <script type="text/javascript" src="https://cdn.mazing.link/mzg-in.js"></script>

let currentProduct;
let initializing = false;
let optionsListenerAttached = false;

let placementObserverAttached = false;
let reinitTimeout = null;

const isMobileView = () => window.innerWidth < 750;

const hasMazingButtonInPlacement = () => {
    const placement = document.querySelector('.pwzrswiper-container');
    if (!placement) {
        return false;
    }

    return !!placement.querySelector('.mazing-button-container');
};

const reinitializeMazingInPlacement = async () => {
    const placement = document.querySelector('.pwzrswiper-container');
    if (!placement) {
        return;
    }

    document.querySelectorAll('.mazing-button-container').forEach(btn => btn.remove());
    document.querySelectorAll('#mazing-popup-container').forEach(popup => popup.remove());

    await initializeMazing();
    console.log('Mazing re-initialized after placement rerender.');
};

const bindPlacementObserver = async () => {
    if (placementObserverAttached) {
        return;
    }

    const placement = await waitForElement('.pwzrswiper-container');
    if (!placement) {
        console.warn('No placement container found.');
        return;
    }

    const observer = new MutationObserver(() => {
        if (!isMobileView()) {
            return;
        }

        clearTimeout(reinitTimeout);
        reinitTimeout = setTimeout(async () => {
            const currentPlacement = document.querySelector('.pwzrswiper-container');
            if (!currentPlacement) {
                return;
            }

            if (!hasMazingButtonInPlacement()) {
                console.log('Placement rerender detected, reinitializing Mazing...');
                await reinitializeMazingInPlacement();
            }
        }, 150);
    });

    observer.observe(document.body, {
        childList: true,
        subtree: true
    });

    placementObserverAttached = true;
    console.log('Placement observer attached.');
};

let lastIsMobile = isMobileView();

const bindResizeListener = () => {
    window.addEventListener('resize', () => {
        const nowIsMobile = isMobileView();
        if (nowIsMobile === lastIsMobile) {
            return;
        }

        lastIsMobile = nowIsMobile;

        setTimeout(async () => {
            if (!document.querySelector('.pwzrswiper-container')) {
                return;
            }

            if (!hasMazingButtonInPlacement()) {
                await reinitializeMazingInPlacement();
            }
        }, 150);
    });
};

const waitForMazingFunction = new Promise((resolve) => {
    const interval = 50;
    const checkInterval = setInterval(() => {
        if (typeof mazing === 'function') {
            clearInterval(checkInterval);
            resolve();
        }
    }, interval);
});

const waitForElement = (selector, timeout = 55000) => {
    return new Promise((resolve) => {
        const interval = 50;
        let elapsedTime = 0;

        const checkInterval = setInterval(() => {
            const element = document.querySelector(selector);
            if (element) {
                clearInterval(checkInterval);
                resolve(element);
            } else if ((elapsedTime += interval) >= timeout) {
                clearInterval(checkInterval);
                resolve();
            }
        }, interval);
    });
};

const initializeMazing = async () => {
    await mazing({
        customerName: 'JBJB3OFFICIALCOM',
        buttonConfiguration: {
            customStyle: `
                .mazing-button-container {
                    padding-left: 28px;
                    padding-right: 28px;
                    padding-bottom: 14px;
                    width: 100%;
                    position: absolute;
                    bottom: 0;
                    left: 0;
                    z-index: 1;
                    justify-content: end;
                }
                
                .mazing-ar-btn-icon,
                .mazing-threed-btn-icon {
                    filter: brightness(0) saturate(100%) invert(100%);
                    width: fit-content !important;
                    margin: 0 !important;
                }
                
                .mazing-threed-btn,
                .mazing-ar-btn { 
                    background: black !important;        
                    box-shadow: none !important;
                    display: flex;
                    justify-content: space-around; 
                    gap: 10px;
                    padding-left: 24px;
                    border-radius: 0px;
                    padding-right: 24px;
                    position: relative;
                    overflow: hidden;
                    z-index: 1;
                }
                
                .mazing-threed-btn-text,
                .mazing-ar-btn-text{
                    font-weight: 600;
                    color: white;
                }
                
                .mazing-threed-btn::before,
                .mazing-ar-btn::before {
                    content: "";
                    position: absolute;
                    top: 0;
                    left: 0;
                    height: 100%;
                    width: 100%;
                    background: rgba(255, 255, 255, 0.15);
                    transform: scaleX(0);
                    transform-origin: left;
                    transition: transform 0.3s ease;
                    z-index: -1;
                }
                
                .mazing-threed-btn:hover::before,
                .mazing-ar-btn:hover::before {
                    opacity: 1 !important;
                    transform: scaleX(1);
                }
            `,
            placementSelector: '.pwzrswiper-container',
            threedBtn: {
                enabled: true,
                icon: true,
                customText: (() => {
                    const lang = navigator.language || navigator.userLanguage;
                    const translations = {
                        'en': 'View in 3D',
                        'de': 'In 3D ansehen',
                        'fr': 'Voir en 3D',
                        'es': 'Ver en 3D'
                    };

                    return translations[lang.split('-')[0]] || translations['en'];
                })()
            },
            arBtn: {
                enabled: false,
                icon: false,
                customText: (() => {
                    const lang = navigator.language || navigator.userLanguage;
                    const translations = {
                        'en': 'View in Room',
                        'de': 'Im Raum anzeigen',
                        'fr': 'Voir dans votre espace',
                        'es': 'Ver en tu espacio'
                    };

                    return translations[lang.split('-')[0]] || translations['en'];
                })()
            }
        },
        getSKU: getCurrentSKU
    });

    console.log('Mazing initialized.');
};

const getCurrentSKU = () => {
    // const url = window.location.href;
    //
    // const parts = url.split("/");
    // const product = parts.filter(part => part.trim() !== '').pop();
    // const baseSKU = product.split('?')[0].toLowerCase();

    const titleEl = document.querySelector('.product__title h1, .product__title h2');
    let baseSKU = titleEl?.textContent?.trim().toLowerCase() || 'product';

    baseSKU = baseSKU.replace(/\s+/g, '-');

    const getSelectedOption = (optionName) => {
        const container = document.querySelector(`[data-option="${optionName}"]`);
        if (!container) {
            return null;
        }

        const selected = Array.from(container.querySelectorAll('[data-option-value]')).find((el) => {
            const style = window.getComputedStyle(el);
            return (
                el.getAttribute('aria-pressed') === 'true' ||
                el.classList.contains('active') ||
                style.backgroundColor === 'rgb(0, 0, 0)'
            );
        });

        const button = selected || container.querySelector('[data-option-value]');
        return button?.getAttribute('data-option-value')?.toLowerCase() || null;
    };

    const color = getSelectedOption('Color');
    const size = getSelectedOption('Size');

    console.log('Selected Color: ', color);
    console.log('Selected Size: ', size);

    let finalSKU = baseSKU;

    if (size) {
        finalSKU += `-${size}`;
    }
    if (color) {
        finalSKU += `-${color.replace(/\s+/g, '-')}`;
    }

    console.log('Final SKU:', finalSKU);

    return finalSKU;
};

const bindOptionListeners = async () => {
    if (optionsListenerAttached) {
        return;
    }

    const optionsRoot = await waitForElement('.rio-options');
    if (!optionsRoot) {
        console.warn('No .rio-options found.');
        return;
    }

    optionsRoot.addEventListener('click', async (event) => {
        const optionButton = event.target.closest('[data-option-value]');
        if (!optionButton) {
            return;
        }

        console.log('Clicked option: ', optionButton);

        setTimeout(async () => {
            const sku = getCurrentSKU();
            console.log('Refreshing SKU:', sku);

            if (typeof mazingRefreshSKU === 'function') {
                try {
                    setTimeout(async () => {
                        await mazingRefreshSKU(getCurrentSKU(), 'JBJB3OFFICIALCOM');
                    }, 0)
                } catch (error) {
                    console.error('refreshSKU failed:', error);
                }
            } else {
                console.warn('refreshSKU is not available.');
            }
        }, 800);
    });

    optionsListenerAttached = true;
    console.log('Option listeners attached.');
};


const initializeScript = async () => {
    if (initializing) {
        return;
    }
    initializing = true;

    try {
        await waitForMazingFunction;
        console.log('mazingProjectAvailable is now available');

        await waitForElement('.pwzrswiper-container')

        document.querySelectorAll('.mazing-button-container').forEach(btn => btn.remove());
        document.querySelectorAll('#mazing-popup-container').forEach(popup => popup.remove());

        await initializeMazing();
        await bindOptionListeners();

        await bindPlacementObserver();
        bindResizeListener();

        console.log('Initialized successfully.');
    } catch (error) {
        console.error('Initialization failed:', error);
    } finally {
        initializing = false;
    }
};

initializeScript();
